@if (visible()) {
  <section class="testimonials">
    <div class="container">
      <div class="section-header">
        <span class="section-subtitle">Google értékelések</span>
        <h2 class="section-title">Visszajelzések a Google-től</h2>
      </div>

      <div class="testimonials__grid">
        @for (row of rows(); track row.trackKey) {
          <div class="testimonial-card">
            <div class="testimonial-card__stars">
              @for (star of getStars(row.rating); track $index) {
                <span class="star">★</span>
              }
            </div>
            <p
              #reviewText
              class="testimonial-card__text"
              [class.is-expanded]="isExpanded(row.trackKey)"
              [attr.data-key]="row.trackKey"
            >
              „{{ row.text }}"
            </p>
            @if (isOverflowing(row.trackKey)) {
              <button
                type="button"
                class="testimonial-card__toggle"
                (click)="toggleExpanded(row.trackKey)"
              >
                {{ isExpanded(row.trackKey) ? 'mutass kevesebbet' : 'mutass többet…' }}
              </button>
            }
            <div class="testimonial-card__author">
              <div class="testimonial-card__avatar">
                {{ avatarLetter(row.name) }}
              </div>
              <div class="testimonial-card__author-text">
                <span class="testimonial-card__name">{{ row.name }}</span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </section>
}
